/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBeePollen = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M18 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" />
        <path d="M20.84 6.858a10.973 10.973 0 0 0-8.94 1.05 5.235 5.235 0 0 0-.165-1.786c-.483-1.804-1.85-3.165-3.551-3.58l-.532-.13-.396.379C6.187 3.81 5.631 5.317 5.79 6.864c-1.3-.357-2.674-.186-3.802.5l-.468.284-.012.548c-.04 1.735.892 3.443 2.523 4.384a5.063 5.063 0 0 0 3.204.644 10.954 10.954 0 0 0-.592 6.845L6 22l1.517-.506c3.832 1.212 8.195.3 11.236-2.74a11.129 11.129 0 0 0 2.738-11.246 1 1 0 0 0-.65-.65zm-12.098 8.06a10.037 10.037 0 0 0 4.348 4.826 9.176 9.176 0 0 1-4.47-.014 8.932 8.932 0 0 1 .122-4.812zm8.597 2.421a9.156 9.156 0 0 1-1.682 1.33 8.012 8.012 0 0 1-5.61-6.39 9.552 9.552 0 0 1 1.835-1.933 8.008 8.008 0 0 0 6.15 6.217 9.246 9.246 0 0 1-.693.776zm2.39-8.72a9.16 9.16 0 0 1-.557 6.098 6.002 6.002 0 0 1-5.434-5.515l-.018.002a8.96 8.96 0 0 1 6.01-.584zm-12.21 2.495a3.02 3.02 0 0 1-2.487-.265 3.02 3.02 0 0 1-1.473-2.021c.756-.253 1.655-.183 2.473.289.818.473 1.328 1.216 1.487 1.997zm1.925-2.01a3.02 3.02 0 0 1-1.571-1.946 3.02 3.02 0 0 1 .388-2.47c.713.355 1.299 1.04 1.544 1.953.244.912.079 1.799-.361 2.463z" />
      </g>
    </g>
  </Icon>
);
export { SvgBeePollen as BeePollen };
